import React, { Component } from 'react';

import { Copy, Paragraph, Button } from '../../theme';
import { isMobile } from '../../util';
import { Mecanism } from '../../svg';

class CampaignMecanism extends Component {
  render() {
    return (
      <div id="ArcticEnel" className="container__fluid mecansim">
        <div className="w__flex w__flex-column Justify-between Align-center">

          {
            !isMobile && (
              <div className="baloon">
                <Mecanism.Baloon />
              </div>
            )
          }

          <div style={{ marginTop: '8.33333vh' }} className="cell">

            <Copy normal alignRight padding="0vw" >
              <span>Schimba doua lucruri</span>
              <span>cu o singura mutare!</span>
            </Copy>
          </div>

          <div className="w__flex w__flex-column__mobile">

            <div className="client__container client-arctic">
              <div className="client__img-header Self-end">
                <img src={require('../../../assets/img/arctic-image-header.png')} alt="" />
              </div>
              <div className="client__logo">
                <img src={require('../../../assets/img/logos/logo-arctic-mecanism.png')} alt="" />
              </div>
              <div className="client-testimony">
                <Paragraph normal>
                  In incercarea de a sprijini consumatorii sa adopte un stil de viata responsabil fata de mediul, Arctic a creat o noua generatie de electrocasnice ce ofera economie de energie si apa, timp si bani, performante in utilizare, siguranta sporita si confort in folosire.
                </Paragraph>
              </div>
            </div>

            <div className="client__container client-enel">
              <div className="client__img-header">
                <img src={require('../../../assets/img/enel-image-header.png')} alt="" />
              </div>
              <div className="client__logo">
                <img src={require('../../../assets/img/logos/logo-enel-mecanism.png')} alt="" />
              </div>
              <div className="client-testimony">
                <Paragraph normal>
                  Enel investeste continuu in sectorul energiei regenerabile, contribuind la transformarea Romaniei intr-un lider mondial in acest domeniu si al practicilor sustenabile. Angajamentul Enel este de a oferi clientilor stabilitate, servicii cu valoare adaugata, intr-un parteneriat pe termen lung cu un furnizor integrat de servicii de utilitati.
                </Paragraph>
              </div>
            </div>

          </div>


          <div className="Self-start">
            <Button enel >
              <span className="mobile__hidden">Vezi</span>  oferta enel
            </Button>
          </div>

          <div className="footer" style={{ zIndex: 1005 }}>
            <div>
              <ul style={{ zIndex: 1005 }}>
                <li>©2018 Arctic.ro</li>
                <li>
                  <a href="http://www.infinitsolutions.ro/"><img src={require('../../../assets/img/logos/infinit.png')} alt="" /></a>
                </li>
              </ul>
              <ul style={{ zIndex: 1005 }}>
                <li><a href="https://www.arctic.ro/termeni_conditii">Termeni si conditii</a></li>
                <li><a href="https://www.arctic.ro/cookies">Politica cookies</a></li>
                <li><a href="https://www.arctic.ro/privacy">Politica {!isMobile ? 'de prelucrare a' : ''} datelor</a></li>
                <li><a href={require('../../../assets/regulament.pdf')}>Regulamentul campaniei</a></li>
              </ul>
            </div>
            {
              !isMobile && (
                <div style={{}} className="border_footer">&nbsp;</div>
              )
            }
          </div>

        </div>
      </div >
    );
  }
}

export default CampaignMecanism;


// WEBPACK FOOTER //
// ./src/components/pages/Mecanism/ArcticEnel.jsx